import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import AccountService from '../account.service';
import { IPlan } from '@/shared/model/plan.model';
import { utils } from '@/shared/utils';
import currencyFormatter from 'currency-formatter';
import { StripeElements, StripeElement } from 'vue-stripe-elements-plus';
import { stripeKey, stripeOptions } from '@/shared/config/stripe-config';
import UpgradeService from './upgrade.service';
import PlanService from '@/entities/plan/plan.service';
import moment from 'moment';
import PaymentMethod  from './payment-method.vue';
import ProductItem  from './product-item.vue';
import { IAddon, Addon } from '@/shared/model/addon.model';
import AddonService from '@/entities/addon/addon.service';
import UserActivityService from '@/entities/user-activity/user-activity.service';
import { getCheckoutPlanOptionFromNickname } from '@/shared/data/plan-option-util';
import { buildInvoiceItem, buildSubscriptionItem,
  getAdditionalAuthors, getIvoiceSubscriptionItems,
  getRelated, removePlanByNamePartial, removePlanLearnerType,
  showQtyInSelect, updateAdditionalAuthors } from '@/shared/data/plan-utils';

@Component({
  components: {
    StripeElements,
    StripeElement,
    PaymentMethod,
    ProductItem
  }
})
export default class UpdatePlan extends Vue {
  @Inject('accountService')
  private accountService: () => AccountService;

  @Inject('upgradeService')
  private upgradeService: () => UpgradeService;

  @Inject('planService')
  private planService: () => PlanService;

  @Inject('addonService')
  private addonService: () => AddonService;

  @Inject('userActivityService')
  private userActivityService: () => UserActivityService;

  @Prop({type: String, default: null})
  planNickname: string;

  @Prop({type: Object, default: null})
  checkoutUserDto: any;

  @Prop({type: Object, default: null})
  subscription: any;

  @Prop({type: String, default: 'Subscribe'})
  checkoutBtn: string;

  @Prop({type: String, default: null})
  planToAdd: string;

  @Prop({type: String, default: 'year'})
  billingCycle: string;

  @Prop({type: Boolean, default: true})
  allowPlanChange: boolean;

  @Prop({type: Boolean, default: true})
  updateBillingMode: boolean;

  @Prop({type: Boolean, default: false})
  updateAuthor: boolean;

  @Prop({type: Boolean, default: false})
  addSuitePlan: boolean;

  @Prop({type: String, default: null})
  couponCode: string;

  public qtyDialog = false;

  public downgradePlan: IPlan = null;
  public plansDialog = false;
  public showDetails = false;
  public onlyPaymentMethodUpdate = false;
  public pleaseWait = false;
  public initialLoad = false;
  public showPlans = false;
  public billingCycles = [
    { text: 'Billed Annually', value: 'year' },
    { text: 'Billed Monthly', value: 'month' }
  ];
  public userAddOnList: IAddon[] = [];
  public userAddOn = null;
  public authorCount = 1;
  public isSilver = false;
  public plan: IPlan = null;
  public plans: IPlan[] = [];
  public availablePlans = [];
  public selectedPlans = [];
  public stripeCustomerData = null;
  public stripeEstimates = null;
  public loggedUser = null;
  public estimateToken = null;
  public showCustomControls = false;
  public changePaymentMethod = false;
  public coupon = null;
  public couponAmount = null;
  public couponDescription = null;
  public couponError = false;
  public showCouponControls = false;
  public showCouponLineItem = false;
  public stripeSubscription = null;
  public cardInfoCompleted = false;
  public cardError = '';
  public stripeKey = stripeKey;
  public invoiceItems = [];
  public allPlans = [];
  public subscriptionItems = [];
  public stripeOptions = stripeOptions;
  public elementsOptions = {};
  public cardOptions =  {
    // reactive
    // remember about Vue 2 reactivity limitations when dealing with options
    value: {
      postalCode: '',
    },
    iconStyle: 'default',
    style: {
      base: {
        color: '#303238',
        lineHeight: '30px',
        fontSize: '16px',
        fontFamily: '"proxima-nova", "Open Sans", sans-serif',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#CFD7DF',
        },
      },
      invalid: {
        color: '#e5424d',
        ':focus': {
          color: '#303238',
        },
      },
    },
    // https://stripe.com/docs/stripe.js#element-options
  };
  public rules = {
    required: (v) => {
      if (!v) {
return 'Must be valid number.';
}
      if (v > 0 && v <= 999) {
return true;
}
      return 'Must be valid number.';
    },
  };

  public headers = [
    { text: 'Name', value: 'productName' },
    { text: 'Qty', value: 'quantity' },
    { text: 'Total', value: 'computedAmountPerPeriod' }
  ];

  @Watch('authorCount')
  authorCountChange() {
    if (this.authorCount && this.authorCount > 0) {
      if (this.isSilver) {
        this.authorCount = 1;
      }
      this.getEstimate();
    }
  }

  @Watch('billingCycle')
  billingCycleChange() {
    this.updateSubscriptionItems();
    this.getEstimate();
  }


  async created() {
    this.stripeKey = await this.upgradeService().getStripePublishableKey(stripeKey);
    this.loggedUser = this.accountService().authenticated ? this.$store.getters.account : null;

    if (this.subscription && this.subscription.scheduleDowngrade) {
      this.retrieveDowngradePlan();
    }

    this.allPlans = await this.upgradeService().getAllPlans();
    this.allPlans.forEach((elm) => {
      elm['disabled'] = false;
    });


  }

  async mounted() {
    try {
      this.stripeSubscription = await this.upgradeService().getSubscriptionById(this.subscription.stripeId);
    } catch (err) {
      let msg = 'Unable to retrieve subscription information. Please contact your account admin or support@elblearning.com for assistance.';
      this.$swal.fire({
        icon: 'error',
        text: msg,
        confirmButtonColor: '#000C19',
        showConfirmButton: true,
      }).finally(() => {
        this.$router.push('/');
      });
    }
    const items = this.stripeSubscription.items;
    for (let i = 0; i < items.data.length; i++) {
      const related = getRelated(items.data, items.data[i]);
      const relatedAuthor = buildSubscriptionItem(related['relatedAuthor']);
      const relatedLearner = buildSubscriptionItem(related['relatedLearner']);
      const subsItem = buildSubscriptionItem(items.data[i]);
      subsItem.relatedAuthor = relatedAuthor;
      subsItem.relatedLearner = relatedLearner;

      this.billingCycle = items.data[i].price.recurring.interval;

      this.subscriptionItems.push(subsItem);
    }
    this.initialLoad = true;


    if (this.accountService().authenticated) {
      if (!this.checkoutUserDto) {
        // @todo: get application user here
        this.stripeCustomerData = this.stripeSubscription.customer;

        if (this.subscriptionChangeScheduled) {
          this.$emit('hasDowngrade');
          this.$router.go(-1);
          return;
        }
      }
    }


    if (this.subscription && this.subscription.addons && this.subscription.addons.length && this.isPlatinum) {
      this.subscription.addons.forEach((elm) => {
        if (elm.type === 'userCount') {
          this.userAddOn = elm;
        }
      });
    }

    this.selectedPlans = [];

    if (this.planToAdd) {
      this.updateAvailablePlans();
      const item = await this.upgradeService().getPlanById(this.planToAdd);
      const subItem = this.availablePlans.find((val) => val.priceId === item.priceId);
      this.selectedPlans.push(subItem);
      this.addPlans();
    } else {
      if (!this.subscriptionCancelled) {
        this.getEstimate();
      }
    }

    // if (!this.subscriptionCancelled) {
    //   await this.getEstimate();
    // }

    // if (this.planToAdd) {
    //   this.updateAvailablePlans();
    //   const item = await this.upgradeService().getPlanById(this.planToAdd);
    //   const subItem = this.availablePlans.find(val => val.priceId === item.priceId);
    //   this.selectedPlans.push(subItem);
    //   this.addPlans();
    // }

    if (this.couponCode) {
      this.coupon = this.couponCode;
      this.showCouponControls = true;
      this.applyCoupon();
    }
    this.initialLoad = false;
  }


  public get hasAnnaulPriceOnly() {
    if (this.subscription) {
      return this.subscription && (
        this.subscription.plan.nickname.includes('_gov') ||
        this.subscription.plan.nickname.includes('_edu') ||
        this.subscription.plan.nickname.includes('_k12')
      );
    }

    return false;
  }

  public updateSubscriptionItems() {
    console.log(this.planNickname);
    const cleanPlan = getCheckoutPlanOptionFromNickname(this.planNickname, this.allPlans);
    for (let i = 0; i < this.subscriptionItems.length; i++) {
      this.updateSubscriptionItem(this.subscriptionItems[i], cleanPlan);
      if (this.subscriptionItems[i].relatedAuthor) {
        this.updateSubscriptionItem(this.subscriptionItems[i].relatedAuthor, cleanPlan);
      }

      if (this.subscriptionItems[i].relatedLearner) {
        this.updateSubscriptionItem(this.subscriptionItems[i].relatedLearner, cleanPlan);
      }
    }
  }

  public updateSubscriptionItem(item, cleanPlan) {
    const plan = cleanPlan.find((plan) => plan['productName'] === item.productName && plan['interval'] === this.billingCycle);
      if (plan) {
        item.interval = plan['interval'];
        item.unitPrice = plan['unitPrice'];
        item.priceId = plan['priceId'];
        item.billing = plan['billing'];
        item.unitAmount = currencyFormatter.format(item.unitPrice / 100.0, { code: 'USD' });
      }
  }

  public getUnitPriceForTier(tiers, quantity) {
    for (let i = 0; i < tiers.length; i++) {
      const tier = tiers[i];
      if (tier.up_to == null) {
        return tier.unit_amount_decimal;
      }
      if (tier.up_to >= quantity) {
        return tier.unit_amount_decimal;
      }
    }
  }

  public getUnitPriceForTierCamel(tiers, quantity: number) {
    for (let i = 0; i < tiers.length; i++) {
      const tier = tiers[i];
      if (tier.upTo == null) {
        return tier.unitAmountDecimal;
      }
      if (tier.upTo >= quantity) {
        return tier.unitAmountDecimal;
      }
    }
  }


  public addViewers() {
    const item = this.allPlans.find((val) => val.productName.includes('viewers') && val.interval === this.billingCycle);
    const platinum = this.selectedPlans.find((val) => val.productName.includes('Platinum'));
    if (item && platinum) {
      const viewers = {
        quantity: 100,
        priceId: item.priceId,
        interval: item.interval,
        deleted: false,
        added: true,
        productName: item.productName,
        unitPrice: item.unitPrice,
        billing: item.billing
      };
      this.selectedPlans.push(viewers);
    }
  }

  public removePlatByNamePartial(name) {
    const index = this.availablePlans.findIndex((v) => v.productName.includes(name));
    if (index !== -1) {
      this.availablePlans.splice(index, 1);
    }
  }

  public removeExistingPlans() {
    for (let i = 0; i < this.subscriptionItems.length; i++) {
      this.removePlatByNamePartial(this.subscriptionItems[i].productName);
    }
  }

  public updateAvailablePlans() {
    const planNickname = this.subscription ? this.subscription.plan.nickname : null;
    const cleanPlans = getCheckoutPlanOptionFromNickname(planNickname, this.allPlans);
    this.availablePlans = cleanPlans.filter((val) => val['interval'] === this.billingCycle);

    // remove CVR viewers
    removePlanByNamePartial(this.availablePlans,'viewers');

    // remove Ptlatinum
    removePlanByNamePartial(this.availablePlans,'Platinum');

    // remove Ptlatinum
    removePlanByNamePartial(this.availablePlans, 'Silver');

    // remove existing plans
    this.removeExistingPlans();

    this.availablePlans = removePlanLearnerType(this.availablePlans);


    const gold = this.subscriptionItems.find((val) => val.productName.includes('Gold'));
    if (gold) {
      removePlanByNamePartial(this.availablePlans,'Silver');
      removePlanByNamePartial(this.availablePlans,'Gold');
    }


    const platinum = this.subscriptionItems.find((val) => val.productName.includes('Platinum'));
    if (platinum) {
      for (let i = 0; i < this.availablePlans.length; i++) {
        if (this.availablePlans[i].productName.includes('Silver') ||
            this.availablePlans[i].productName.includes('Platinum')) {
          this.availablePlans[i].disabled = true;
        }

        if (this.availablePlans[i].productName.includes('viewers')) {
          this.availablePlans[i].disabled = false;
        }
      }
    }

    const viewers = this.subscriptionItems.find((val) => val.productName.includes('viewers'));
    if (viewers) {
      for (let i = 0; i < this.availablePlans.length; i++) {
        if (this.availablePlans[i].productName.includes('Silver') || this.availablePlans[i].productName.includes('viewers')) {
          this.availablePlans[i].disabled = true;
        }
      }
    }
  }

  public retrieveAddons() {
    const addonPaginationQuery = {
      page: 0,
      size: 50,
      sort: ['id,asc'],
      predicate : [
        {name: 'type.equals', value: 'userCount'}
      ]
    };

    this.addonService()
    .retrieve(addonPaginationQuery)
    .then( (addons) => {
      this.userAddOnList = addons.data;
    });
  }

  public removeRelatedAuthorOnly() {
    const authorOnlyToRemove = this.selectedPlans.find((val) => val.price && val.price.metadata && val.price.metadata.authorOnly);
    if (authorOnlyToRemove) {
      const authorOnlyPlanIndex = this.subscriptionItems.findIndex((val) => val.priceId === authorOnlyToRemove.price.metadata.authorOnly);
      if (authorOnlyPlanIndex >= 0) {
        this.removeItem(authorOnlyPlanIndex);
      }
    }
  }

  public addPlans() {
    this.addViewers();
    this.removeRelatedAuthorOnly();
    const silverPlan = this.hasSiverPlan;
    for (let i = 0; i < this.selectedPlans.length; i++) {
      const quantity = showQtyInSelect(this.selectedPlans[i]) ? 100 : 1;
      const subsItem = {
        quantity,
        priceId: this.selectedPlans[i].priceId,
        interval: this.selectedPlans[i].interval,
        deleted: false,
        added: true,
        productName: this.selectedPlans[i].productName,
        unitPrice: this.selectedPlans[i].unitPrice,
        billing: this.selectedPlans[i].billing
      };

      this.subscriptionItems.push(subsItem);

      if (silverPlan) {
        silverPlan.deleted = true;
      }
    }

    if (this.selectedPlans.length > 0) {
      this.getEstimate();
    }

    this.plansDialog = false;
    this.selectedPlans = [];
  }

  public retrievePlan() {
    this.planService()
      .findByNickname(this.planNickname)
      .then((res) => {
        this.plan = res;
        this.isSilver = res.nickname.includes('silver');
      });
  }

  public retrievePlans(): void {
    const paginationQuery = {
      page: 0,
      size: 50,
      sort: ['id,asc'],
      predicate : [
        {name: 'active.equals', value: true},
        {name: 'nickname.in', value: 'elb_silver_suite,elb_gold_suite,elb_platinum_suite'}
      ]
    };
    this.planService()
      .retrieve(paginationQuery)
      .then((res) => {
        this.plans = res.data;
      });
  }

  public get isPlatinum() {
    return this.planNickname.includes('platinum');
  }

  public getPlanNickname() {
    let planName = this.plan ? this.plan.nickname : this.planNickname;
    if (this.billingCycle === 'monthly' && !planName.includes('_monthly')) {
      planName += '_monthly';
    }
    return planName;
  }

  public async cancelSubscription() {
    if (this.subscriptionNotRenew) {
      try {
        await this.upgradeService().stripeReinstateSubscription(this.subscription.id);
      } catch (e) {
        console.error(e);
      }
    } else if (this.scheduledDowngrade) {
      try {
        await this.upgradeService().stripeCancelDowngrade(this.subscription.id);
      } catch (e) {
        console.error(e);
      }
    }

    this.pleaseWait = true;
    try {
      await this.upgradeService().stripeCancelSubscription(this.getUserDto());

      await this.userActivityService()
      .createEvent(this.$store.getters.account, this.$store.getters.currentLocation, 'canceled subscription' , 'canceled' );

      this.$emit('subCancel');
    } catch (e) {
      this.pleaseWait = false;
    }
  }


  public getUserDto() {
    const dto = {
      id: this.checkoutUserDto ? this.checkoutUserDto.id : this.loggedUser.userId,
      email: this.checkoutUserDto ? this.checkoutUserDto.email : this.loggedUser.email,
      planNickname: this.getPlanNickname(),
      firstName: this.checkoutUserDto ? this.checkoutUserDto.firstName : this.loggedUser.firstName,
      lastName: this.checkoutUserDto ? this.checkoutUserDto.lastName : this.loggedUser.lastName,
      organizationName: this.checkoutUserDto ? this.checkoutUserDto.organizationName : this.loggedUser.organizationName,
      organizationId: this.checkoutUserDto ? this.checkoutUserDto.organizationId : this.loggedUser.organizationId,
      numberOfAuthors: this.authorCount != null && this.authorCount > 0 ? this.authorCount : 1,
      coupon: this.couponError ? null : this.coupon,
      billingCycle: this.billingCycle,
      country: this.userCountry,
      postalCode: this.userPostalCode,
      token: null,
      prorationDate: null,
      subscription: this.subscription  ?  this.subscription : null,
      userAddon: this.getUserAddon(),
      addSuitePlan: this.addSuitePlan,
      subscriptionItemCollection: this.subscriptionItems
    };
    return dto;
  }

  public async applyCoupon() {
    if (this.coupon == null) {
      this.showCouponControls = false;
      return;
    }
    this.pleaseWait = true;
    this.couponError = false;
    this.couponAmount = null;
    this.showCouponLineItem = false;
    try {
      const couponData = await this.upgradeService().getStripeCoupon(this.coupon);
      this.pleaseWait = false;
      if (couponData.valid) {
        if (couponData.amount_off != null) {
          this.couponDescription = `${currencyFormatter.format(Number.parseInt(couponData.amount_off) / 100.0, { code: 'USD' })} off`;
          this.couponAmount = currencyFormatter.format(Number.parseInt(couponData.amount_off) / 100.0, { code: 'USD' });
        } else{
          this.couponDescription = `${couponData.percent_off}% off`;
      }

        if (couponData.duration === 'once') {
          this.couponDescription += ' initial subscription';
        }
        this.showCouponLineItem = true;
        this.getEstimate();
      } else {
        // this.coupon = null;
        this.couponError = true;
        this.couponDescription = 'Coupon is not active or is not valid for this items.';
        this.pleaseWait = false;

      }
    } catch (e) {
      console.log(e);
      // this.coupon = null;
      this.couponError = true;
      this.couponDescription = 'Coupon is not active or is not valid for this items.';
      this.pleaseWait = false;
    }
  }

  public getUserAddon() {
    const item = this.subscriptionItems.find((val) => val.productName.includes('viewers'));
    if (item) {
      const userAddon: Addon = new Addon();
      userAddon.type = 'userCount';
      userAddon.value = item.deleted ? 0 : item.quantity;
      userAddon.maxValue = item.deleted ? 0 : item.quantity;

      return userAddon;
    }

    return null;
  }

  public get allProductsDeleted() {
    for (let i = 0; i < this.subscriptionItems.length; i++) {
      if (!this.subscriptionItems[i].deleted) {
        return false;
      }
    }

    return true;
  }

  public async cancelDowngrade() {
    try {
      await this.upgradeService().stripeCancelDowngrade(this.subscription.id);
    } catch (e) {
      console.error(e);
    }
    this.$emit('done');
  }


  public getEstimate() {
    if (this.subscriptionCancelled) {
      return;
    }

    if (this.allProductsDeleted) {
      this.updateAvailablePlans();
      this.loadIvoiceSubscriptionItems();
      this.pleaseWait = false;
      // this.$swal.fire({
      //   icon: 'warning',
      //   text: 'Please add at least one plan',
      //   confirmButtonColor: '#000C19',
      //   showConfirmButton: true,
      //   timer: 4500
      // })
      return;
    }

    this.showDetails = false;
    this.stripeEstimates = null;
    this.pleaseWait = true;
    const userDto = this.getUserDto();


    if (this.estimateToken) {
      userDto.country = this.estimateToken.token.card.country;
      userDto.postalCode = this.estimateToken.token.card.address_zip;
    }

    this.upgradeService().getStripePlanEstimates(userDto)
    .then((response) => {
      this.stripeEstimates = response;
      this.updateAvailablePlans();
      this.loadIvoiceSubscriptionItems();
    })
    .catch((err) => {
      let msg = 'Sometning went wrong. Please try again.';
      if (err && err.response && err.response.data && err.response.data.title) {
        msg = err.response.data.title;
      }
      this.$swal.fire({
        icon: 'error',
        text: msg,
        confirmButtonColor: '#000C19',
        showConfirmButton: true,
        timer: 4500
      });
    })
    .finally(() =>{
      this.pleaseWait = false;
    });
  }

  public invoiceListUpdated(itemRemoved) {
    for (let i = 0; i < this.subscriptionItems.length; i++) {
      if (itemRemoved.priceId === this.subscriptionItems[i].priceId) {
        this.subscriptionItems[i].deleted = true;
        if (this.subscriptionItems[i].added) {
          this.subscriptionItems.splice(i, 1);
        }
      }
      if (itemRemoved.productName.includes('Platinum') && this.subscriptionItems[i].productName.includes('viewers')) {
        // need to remove cvr viewers
        this.subscriptionItems[i].deleted = true;
        if (this.subscriptionItems[i].added) {
          this.subscriptionItems.splice(i, 1);
        }
      }
    }
    this.getEstimate();
  }

  public invoiceListItemRetored(itemRestored) {
    const isSilver = itemRestored.productName.includes('Silver');
    if (isSilver) {
      this.subscriptionItems = this.subscriptionItems.filter(function( obj ) {
        obj.deleted = false;
        return obj.productName.includes('Silver');
      });
    } else {
      for (let i = 0; i < this.subscriptionItems.length; i++) {
        if (itemRestored.priceId === this.subscriptionItems[i].priceId) {
          this.subscriptionItems[i].deleted = false;
        }

        if (itemRestored.productName.includes('viewers') && this.subscriptionItems[i].productName.includes('Platinum')) {
          // need to restore platinum if viewers is restored
          this.subscriptionItems[i].deleted = false;
        }
      }
    }
    this.getEstimate();
  }

  public invoiceItemQuantityChange(item, additionalAuthors) {
    if (item.quantity === 0 && item.authorOnly) {
      // need to replace item with author only
      this.changeToItemToAuthorOnly(item, additionalAuthors);
    } else {


      this.invoiceItems.forEach((elm) => {
        if (elm.id === item.id) {
          elm.quantity = item.quantity;
        }
      });

      this.subscriptionItems.forEach((elm) => {
        if (elm.priceId === item.priceId) {
          elm.quantity = parseInt(item.quantity);
        }
      });

      this.addOrUpdateAdditionalAuthors(item, additionalAuthors);
    }

    this.getEstimate();
  }

  public removeItem(itemIndex) {
    this.subscriptionItems[itemIndex].deleted = true;
    if (this.subscriptionItems[itemIndex].added) {
      this.subscriptionItems.splice(itemIndex, 1);
    }
  }

  public removeRelated(item) {
    const subscriptionItem = this.subscriptionItems.find((s) => s.priceId === item.priceId);
    if (subscriptionItem) {
subscriptionItem.relatedAuthor = null;
}
  }

  public updateRelated(priceId, related) {
    const subscriptionItem = this.subscriptionItems.find((s) => s.priceId === priceId);
    if (subscriptionItem) {
      subscriptionItem.relatedAuthor = related;
    }
  }

  public addOrUpdateAdditionalAuthors(item, additionalAuthors) {
    if (additionalAuthors === 0 && item.relatedAuthor) {
      const index = this.subscriptionItems.findIndex((s) => s.priceId === item.relatedAuthor.priceId);
      if (index !== -1) {
        this.removeItem(index);
        this.removeRelated(item);
      } else {
        updateAdditionalAuthors(item.relatedAuthor, additionalAuthors);
      }
    } else {
      const additional = getAdditionalAuthors(item, additionalAuthors, this.allPlans);
      if (additional) {
        this.subscriptionItems.push(additional);
        this.updateRelated(item.priceId, buildInvoiceItem(additional, this.allPlans));
      }
    }

  }

  public removeFromSubscriptionItems(itemTndex) {
    if (itemTndex !== -1) {
      this.subscriptionItems.splice(itemTndex, 1);
    }
  }

  public async changeToItemToAuthorOnly(item, additionalAuthors) {
    const qty = item.learnerAuthorList[0].author + additionalAuthors;
    const index = this.subscriptionItems.findIndex((s) => s.priceId === item.priceId);
    if (index !== -1) {
      this.subscriptionItems.splice(index, 1);
      if (item.relatedAuthor) {
        // need to remove additional author prices
        this.removeFromSubscriptionItems(this.subscriptionItems.findIndex((s) => s.priceId === item.relatedAuthor.priceId));
      }
      const newItem = this.allPlans.find((val) => val.priceId === item.authorOnly);

      if (newItem) {
        let learner = null;
        if (newItem.price.metadata) {
          learner = this.allPlans.find((val) => val.priceId === newItem.price.metadata.learner);
          learner = buildInvoiceItem(learner, this.allPlans);
          learner.quantity = 100;
        }
        const subsItem = {
          productName: newItem.productName,
          quantity: qty,
          priceId: newItem.priceId,
          interval: newItem.interval,
          unitPrice: newItem.unitPrice,
          deleted: false,
          added: true,
          billing: newItem.billing,
          learner
        };

        this.subscriptionItems.push(subsItem);
      }
    }
  }

  public toLearner(learner, index, item) {
    if (index !== -1) {
      this.invoiceItems.splice(index, 1);
      this.invoiceItems.splice(index, 1, learner);

      const itemTndex = this.subscriptionItems.findIndex((s) => s.priceId === item.priceId);
      if (itemTndex !== -1) {
        const newItem = this.allPlans.find((val) => val.priceId === learner.priceId);
        if (newItem) {
          const subsItem = {
            productName: learner.productName,
            quantity: learner.quantity,
            priceId: newItem.priceId,
            interval: newItem.interval,
            unitPrice: newItem.unitPrice,
            deleted: false,
            added: true,
            billing: newItem.billing
          };
          this.subscriptionItems.splice(itemTndex, 1);
          this.subscriptionItems.splice(itemTndex, 1, subsItem);
        }
      }
    }
  }


  public loadIvoiceSubscriptionItems() {
    this.invoiceItems = getIvoiceSubscriptionItems(this.subscriptionItems, this.allPlans);
  }

  public async doUpgradePlan() {
    this.pleaseWait = true;
    const userDto = this.getUserDto();
    if (!this.cardOnFile) {
      try {
        const data = await this.createToken();
        if (data.error) {
          this.pleaseWait = false;
          return;
        }
        userDto.token = data.token.id;
        userDto.country = data.token.card.country;
        userDto.postalCode = data.token.card.address_zip;
      } catch (e) {
        console.log('error token creation:', e);
        this.pleaseWait = false;
        return;
      }
    }
    try {
      if (this.onlyPaymentMethodUpdate || this.updateBillingMode) {
        await this.upgradeService().stripeUpdateBilling({
          email: userDto.email,
          token: userDto.token,
          planName: userDto.planNickname,
          billingCycle: userDto.billingCycle
        });

      } else {
        userDto.prorationDate = this.getProrationLineItem.period.start;
        await this.upgradeService().stripeChangePlan(userDto);
        await this.userActivityService()
        .createEvent(this.$store.getters.account, this.$store.getters.currentLocation, 'upgrade subscription' , 'upgraded' );
      }
    } catch (e) {
      this.pleaseWait = false;
      console.log('error with upgrade:', e);
      this.cardError = e.response.data.title;
      if (e.response.data.errorKey === 'subscriptionnotfound') {
        this.onlyPaymentMethodUpdate = true;
      }
      return;
    }
    this.$emit('done');
  }

  public previousState() {
    this.$router.go(-1);
  }

  public async completeCheckout() {
    this.pleaseWait = true;
    const userDTO = this.getUserDto();
    try {
      const data = await this.createToken();
      if (data.error) {
        this.pleaseWait = false;
        return;
      }
      userDTO.token = data.token.id;
      userDTO.country = data.token.card.country;
      userDTO.postalCode = data.token.card.address_zip;
      try {
        await this.upgradeService().stripeCheckout(userDTO);

        await this.userActivityService()
        .createEvent(this.$store.getters.account, this.$store.getters.currentLocation, 'upgraded subscription' , 'upgraded' );

        this.$emit('done');
      } catch (e) {
        this.cardError = e.response.data.title;
        this.pleaseWait = false;
      }
    } catch (e) {
      console.log('error token creation:', e);
      this.pleaseWait = false;
    }
  }


  public async createToken() {
    const groupComponent = this.$refs.elms;
    const cardComponent = this.$refs.card;
    // Get stripe element
    const cardElement = cardComponent['stripeElement'];

    const token = await groupComponent['instance'].createToken(cardElement);
    return token;
  }

  public retrieveDowngradePlan() {
    if (this.subscription.scheduleDowngrade) {
      this.planService()
        .findByNickname(this.subscription.scheduleDowngrade.planName)
        .then((res) => {
          this.downgradePlan = res;
        });
    }
  }


  public getCardIconLink(brand) {
    if (brand) {
      switch(brand.toLowerCase()) {
        case 'visa': return 'https://elearningbrothers-core-content-prod.s3.amazonaws.com/static/icons/cards/visa.svg';
        case 'mastercard': return 'https://elearningbrothers-core-content-prod.s3.amazonaws.com/static/icons/cards/mastercard.svg';
        case 'american express' : return 'https://elearningbrothers-core-content-prod.s3.amazonaws.com/static/icons/cards/american-express.svg';
        case 'diners club' : return 'https://elearningbrothers-core-content-prod.s3.amazonaws.com/static/icons/cards/diners.svg';
        case 'discover' : return 'https://elearningbrothers-core-content-prod.s3.amazonaws.com/static/icons/cards/discover.svg';
        case 'jcb' : return 'https://elearningbrothers-core-content-prod.s3.amazonaws.com/static/icons/cards/jbc.svg';
        case 'unionpay' : return 'https://elearningbrothers-core-content-prod.s3.amazonaws.com/static/icons/cards/unionpay.svgg';
        default: return null;
      }
    }

    return null;
  }

  public get hasScheduledDowngrade() {
    return this.subscription && this.subscription.scheduleDowngrade ? true : false;
  }


  public get subscriptionCancelled() {
    return this.stripeSubscription && this.stripeSubscription.cancel_at_period_end;
  }

  public get getSubscriptionEndDate() {
    return  utils.formatDate(this.subscription.currentTermEnd, 'll');
  }

  public get newCountMessage() {
    if (this.subscription.scheduleDowngrade) {
      let msg = null;
      if (this.subscription.quantity !== this.subscription.scheduleDowngrade.quantity) {
        msg = 'Qty(' + this.subscription.scheduleDowngrade.quantity + ') ' + this.downgradePlan.name;
      }

      if (this.subscription.addons && this.subscription.scheduleDowngrade.viewerQuantity != null) {
        if (this.subscription.addons[0].maxValue !== this.subscription.scheduleDowngrade.viewerQuantity) {
          if (msg == null) {
            msg =  this.subscription.scheduleDowngrade.viewerQuantity + ' viewers';
          } else {
            msg +=  this.subscription.scheduleDowngrade.viewerQuantity + ' viewers';
          }
        }
      }
      return msg;
    }

    return null;
  }

  public get userPostalCode() {
    if (this.stripeCustomerData && this.stripeCustomerData.metadata && this.stripeCustomerData.metadata.Address_PostalCode) {
      return this.stripeCustomerData.metadata.Address_PostalCode;
    }

    return null;
  }

  public get userCountry() {
    if (this.stripeCustomerData && this.stripeCustomerData.metadata && this.stripeCustomerData.metadata.Address_Country) {
      return this.stripeCustomerData.metadata.Address_Country;
    }

    return null;
  }

  public get getProrationLineItem() {
    return this.stripeEstimates.lines.data.find((lineItem) => lineItem.proration);
  }

  public get subscriptionNotRenew() {
    return this.stripeCustomerData &&
           this.stripeCustomerData.subscriptions &&
           this.stripeCustomerData.subscriptions.data &&
           this.stripeCustomerData.subscriptions.data.length ? this.stripeCustomerData.subscriptions.data[0].cancel_at_period_end : false;
  }

  public get scheduledDowngrade() {
    return this.stripeCustomerData &&
           this.stripeCustomerData.subscriptions &&
           this.stripeCustomerData.subscriptions.data &&
           this.stripeCustomerData.subscriptions.data.length ? this.stripeCustomerData.subscriptions.data[0].cancel_at_period_end : false;
  }


  public get subscriptionChangeScheduled() {
    return this.subscriptionNotRenew || this.scheduledDowngrade;
  }

  public get currAuthorCount() {
    return this.subscription ? this.subscription.quantity : null;
  }

  public get isValidCoupon() {
    if (this.couponError) {
      return 'The code you entered is not valid.';
    } else {
      return true;
    }
  }


  public get last4Digits() {
    return this.stripeCustomerData && this.stripeCustomerData.sources.data.length && this.stripeCustomerData.sources.data[0].last4;
  }

  public get cardIcon() {
    if(this.stripeCustomerData && this.stripeCustomerData.sources.data.length && this.stripeCustomerData.sources.data[0].brand) {
      return this.getCardIconLink(this.stripeCustomerData.sources.data[0].brand);
    }

    return null;
  }

  public get cardExpires() {
    if(this.stripeCustomerData &&
      this.stripeCustomerData.sources.data.length &&
      this.stripeCustomerData.sources.data[0].exp_month &&
      this.stripeCustomerData.sources.data[0].exp_year) {
      return this.stripeCustomerData.sources.data[0].exp_month + '/' + this.stripeCustomerData.sources.data[0].exp_year;
    }

    return null;
  }

  public get cardOnFile() {
    console.log('initialLoad', this.initialLoad);
    console.log('authed', this.accountService().authenticated);
    console.log('stripeCustomerData', this.stripeCustomerData);
    console.log('default_source', this.stripeCustomerData.default_source);
    return !this.initialLoad && this.accountService().authenticated &&
            this.stripeCustomerData != null && this.stripeCustomerData.default_source != null;
  }

  public get noCardInfo() {
    return !(this.estimateToken || this.cardOnFile);
  }

  public get taxValue() {
    if (this.checkoutUserDto) {
      return this.stripeEstimates.tax;
    } else if (this.stripeEstimates.metadata.tax) {
      return Number.parseInt(this.stripeEstimates.metadata.tax);
    }

    return 0;
  }

  public get getTaxInfo() {
    let message = 'Fill in card information for tax estimate';
    if (this.noCardInfo) {
      // const tax = this.taxPercentage
      message = 'Estimate tax';
    }
    return message;
  }

  public get taxAmount() {
    const tax = this.taxAmountValue;
    if (tax) {
      return currencyFormatter.format(tax / 100.0, { code: 'USD' });
    }
    return currencyFormatter.format(0.0, { code: 'USD' });
  }

  public get taxAmountValue() {
    if (this.estimateToken || this.cardOnFile) {
      if (this.taxValue > 0) {
        return this.taxValue;
      }

      if (this.stripeEstimates.tax) {
        return this.stripeEstimates.tax;
      }

      if (this.stripeEstimates.metadata.tax_rate) {
        const subTotal = this.getTotalImmediateEstimateValue;
        if (subTotal) {
          const tax = subTotal * (Number.parseFloat(this.stripeEstimates.metadata.tax_rate) / 100.00);
          return tax;
        }
      }
    }
    return null;
  }

  public get upgradeRequiresImmediateFunds() {
    return !this.checkoutUserDto && this.stripeEstimates && Number.parseInt(this.stripeEstimates.metadata.cost) >= 0;
  }

  public get isDowngrade() {
    return !this.checkoutUserDto && this.stripeEstimates && this.stripeEstimates.metadata.isDowngrade === 'true';
  }


  public get getTotalImmediateEstimate() {
    const subTotal = this.getTotalImmediateEstimateValue;
    if (subTotal) {
      return currencyFormatter.format(subTotal / 100.0, { code: 'USD' });
    }

    return null;
  }


  public get getTotalImmediateEstimateValue() {
    if (this.upgradeRequiresImmediateFunds) {
      return Number.parseInt(this.stripeEstimates.metadata.cost);
    } else if (this.checkoutUserDto) {
      let amountDue = this.stripeEstimates.amount_due;
      if (this.taxValue) {
amountDue -= this.taxValue;
}
      return amountDue;
    } else { // null immediate estimate means schedule a downgrade
      const credit = this.proratedCreditValue;
      const amount = this.getTotalRecurringEstimateValue;
      if (credit && amount) {
        const subTotal = credit + amount;
        return subTotal;
      }
      return null;
    }
  }

  public get getTotalImmediateEstimateWithTax() {
    if (this.isDowngrade) {
      return currencyFormatter.format(0, { code: 'USD' });
    }
    const estimate = this.getTotalImmediateEstimateValue;
    const tax = this.taxAmountValue;
    if (estimate) {
      if (tax) {
        const total = Number.parseInt(estimate) + tax;
        return currencyFormatter.format(total / 100.0, { code: 'USD' });
      } else {
        return currencyFormatter.format(estimate / 100.0, { code: 'USD' });
      }

    }
    return null;
  }

  public get getSubscriptionLineItem() {
    return this.stripeEstimates.lines.data.find((lineItem) => lineItem.type === 'subscription');
  }

  public get getInvoiceLineItem() {
    return this.stripeEstimates.lines.data.find((lineItem) => lineItem.type === 'invoiceitem');
  }

  public get getItemTotal() {
    let total = 0;
    for (let i = 0; i < this.stripeEstimates.lines.data.length; i++) {
      const lineItem = this.stripeEstimates.lines.data[i];
      if (lineItem.type === 'subscription' && lineItem.price.id === this.plan.stripeId) {
        total += lineItem.price.unit_amount;
      }
    }
    return currencyFormatter.format(total * this.authorCount / 100.0, { code: 'USD' });
  }

  public get getPlanPrice() {
    let total = 0;
    for (let i = 0; i < this.stripeEstimates.lines.data.length; i++) {
      const lineItem = this.stripeEstimates.lines.data[i];
      if (lineItem.type === 'subscription' && lineItem.price.id === this.plan.stripeId) {
        total += lineItem.price.unit_amount;
      }
    }
    return currencyFormatter.format(total / 100.0, { code: 'USD' });
  }

  public get getTotalRecurringEstimate() {
    return currencyFormatter.format(this.getTotalRecurringEstimateValue / 100.0, { code: 'USD' });
  }

  public get getTotalRecurringEstimateValue() {
    let total = 0;
    for (let i = 0; i < this.stripeEstimates.lines.data.length; i++) {
      const lineItem = this.stripeEstimates.lines.data[i];
      if (lineItem.type === 'subscription') {
        total += lineItem.amount;
      }
    }
    return total;
  }

  public get proratedCredit() {
    const credit = this.proratedCreditValue;
    if (credit) {
      return '-' +  currencyFormatter.format(Math.abs(credit) / 100.0, { code: 'USD' });
    }
    return currencyFormatter.format(0, { code: 'USD' });
  }

  public get proratedCreditValue() {
    let credit = 0;
    for (let i = 0; i < this.stripeEstimates.lines.data.length; i++) {
      const lineItem = this.stripeEstimates.lines.data[i];
      if (lineItem.type === 'invoiceitem' && lineItem.amount < 0) {
        credit += lineItem.amount;
      }

    }

    if (credit !== 0) {
      return credit;
    }
    return 0;
  }

  public get proratedChargeValue() {
    let charge = 0;
    for (let i = 0; i < this.stripeEstimates.lines.data.length; i++) {
      const lineItem = this.stripeEstimates.lines.data[i];
      if (lineItem.type === 'invoiceitem' && lineItem.amount > 0) {
        charge += lineItem.amount;
      }

    }

    if (charge > 0) {
      return charge;
    }
    return null;
  }

  public get proratedCharge() {
    const charge = this.proratedChargeValue;
    if (charge) {
      return currencyFormatter.format(charge / 100.0, { code: 'USD' });
    }
    return null;
  }

  public get discountAmount() {
    console.log('couponAmount:', this.couponAmount);
    if (this.couponAmount) {
      return '-' + this.couponAmount;
    }

    const subscriptionLineItems = this.stripeEstimates.lines.data.filter((lineItem) => lineItem.type === 'subscription');

    console.log('subscriptionLineItems:', subscriptionLineItems);

    if (subscriptionLineItems && subscriptionLineItems.length > 0) {
      let discount = 0;
      for (const element of subscriptionLineItems) {
        if (element.discount_amounts && element.discount_amounts.length > 0) {
          discount += Math.abs(element.discount_amounts[0].amount);
        }
      }

      console.log('discount:', discount);

      if (discount > 0) {
        return '-' + currencyFormatter.format(discount / 100.0, { code: 'USD' });
      }
    }

    console.log('Null:');

    return null;
  }

  public get subscriptionUserCount() {
    if (this.subscription.addons && this.subscription.addons.length > 0 && this.userAddOn) {
      for (let i = 0; i < this.subscription.addons.length; i++) {
        if (this.subscription.addons[i].type === 'userCount') {
          return this.subscription.addons[i];
        }
      }
    }
    return null;
  }

  public get endDate() {
    return utils.getLocalDate(this.subscription.currentTermEnd).format('ll');
  }

  public get showNoChangesMessage() {
    let showNoChanges = true;
    if (this.stripeSubscription) {
      const items = this.stripeSubscription.items;
      if (items.data.length !== this.subscriptionItems.length) {
        showNoChanges = false;
      }
      for (let i = 0; i < items.data.length; i++) {
        const item = this.subscriptionItems.find((lineItem) => lineItem.priceId === items.data[i].price.id);
        if (item) {
          if (item.quantity !== items.data[i].quantity || item.deleted) {
            showNoChanges = false;
          }
        } else {
          showNoChanges = false;
        }

      }
    }
    return showNoChanges;
  }

  public get newSubscriptionStartDate() {
    if (!this.showNoChangesMessage && this.getProrationLineItem) {
      return this.getDateFromTimestamp(this.getProrationLineItem.period.end);
    }
    return null;
  }

  public getDateFromTimestamp(timestamp) {
    return moment.unix(timestamp).format('LL');
  }

  public formatPrice(price) {
    return currencyFormatter.format(price / 100.0, { code: 'USD' });
  }

  public get descriptionTitle() {
    return this.addSuitePlan ? 'Adding' : 'Changing to';
  }


  public get getUserCountSubscriptionLineItem() {
    if (this.userAddOn) {
      for (let i = 0; i < this.stripeEstimates.lines.data.length; i++) {
        const lineItem = this.stripeEstimates.lines.data[i];
        if (lineItem.type === 'subscription' && lineItem.price.id === this.priceId) {
          return lineItem;
        }
      }
      // return this.stripeEstimates.lines.data.find(lineItem => lineItem.price.id === this.priceId && lineItem.type === 'subscription');
    }

    return null;
  }

  public get priceId() {
    if (this.userAddOn) {
      return this.billingCycle === 'monthly' ? this.userAddOn.monthlyStripeId : this.userAddOn.yearlyStripeId;
    }

    return null;
  }

  public get getUserCountTotal() {
    if (this.userAddOn && this.userAddOn.maxValue > 0) {
      const lineItem = this.getUserCountSubscriptionLineItem;
      if (lineItem) {
        return currencyFormatter.format(lineItem.amount  / 100.0, { code: 'USD' });
      }
    }
    return null;
  }

  public get disableCheckout() {
    return this.pleaseWait || this.noCardInfo  || this.showNoChangesMessage;
  }

  public get hasSiverPlan() {
    return this.subscriptionItems.find((item) => item.productName.includes('Silver'));
  }


}
